import {  Button, Card, CardContent, CardHeader, Chip, DialogContentText, Grid, IconButton, Stack, Tooltip } from "@mui/material";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import MUIModal from "../../components/MuiModal";
import { useEffect } from "react";
import { apiConstants, get, post } from "../../common/constants";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { formatDate } from "../../helpers/UtilityHelper";
import EditIcon from '@mui/icons-material/Edit';
import { FormProvider, RHFSearchableSelectField, RHFSelectField, RHFTextField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import LockResetIcon from '@mui/icons-material/LockReset';
import PasswordReset from "./PasswordReset";
import SyncLockIcon from '@mui/icons-material/SyncLock';
import { useSnackbar } from "notistack";
import PageTitle from "../../components/PageTitle";
import Loader from "../../common/Loader";
import { getToken } from "../../helpers/ReduxHelpers";
import jwt_decode from "jwt-decode";
import { Table, TableHead, TableBody, TableRow, TableCell, Typography } from '@mui/material';
import { useGetAllActiveMerchantsIdAndNameCachedQuery } from "../../redux/commonApiCalls";
import StatusToggle from "./StatusToggle";
import { UserModals } from "./UserModal";
import DownloadIcon from '@mui/icons-material/Download';


function UserManagementPanel() {
    const [user, setUser] = useState([])
    const [page, setPage] = useState(0);
    const [reload, setReload] = useState(0)
    const [data, setData] = useState()
    const [editData, setEditData] = useState(null)
    const [filter, setFilter] = useState([])
    const [module, setModule] = useState([])
    const [sizePerPage, setSizePerPage] = useState(20)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [resetPass, setResetPass] = useState(false)
    const [viewMer, setViewMer] = useState(false)
    const [close, setClose] = useState(false)
    const [loginModalOpen, setLoginModalOpen] = useState(false); // To handle Last Logins modal
    const [logins, setLogins] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const userToken = jwt_decode(getToken());
    const [openModal, setOpenModal] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [excludedModules, setExcludedModules] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const { data: merchants = [] } = useGetAllActiveMerchantsIdAndNameCachedQuery()

    const methods = useForm({
        defaultValues: {
            name: "",
            status: "",
            role: "",
            merchant: "",
        }
    });
    const { handleSubmit, reset } = methods;

    // allows access to create and edit
    // const createAccess = true;
    const createAccess = userToken.accessList?.includes("USER_SAVE");

    const MODAL_TYPES = {
        ADD_ADMIN: 'adminUser',
        ADD_USER: 'user',
        EDIT_ADMIN: 'editadmin',
        EDIT_USER: 'edituser',
    }

    // Function to open AddUser modals
    const openAddUserModal = (modalType) => {
        setOpenModal(modalType);
    };

    // Function to open EditUser modals
    const openEditUserModal = (row) => {
        if (row.roles.includes("ROLE_PROSHIPADMIN")) {
            setOpenModal(MODAL_TYPES.EDIT_ADMIN);
        } else {
            setOpenModal(MODAL_TYPES.EDIT_USER)
        }
        setEditData(row)
    };


    const handleClose = () => {
        setResetPass(false)
        setClose(false)
        setLoginModalOpen(false);
        setOpenModal(null);
        setEditData(null)
        setViewMer(false)
        setData(null)
        // setOpenPhoneModal(false)
        // setPhoneData(null)
    }

    const handleReset = (row) => {
        setResetPass(true)
        setData(row)
    }

    const handleResetPassword = (row) => {
        setClose(true)
        setData(row)
    }

    const Reset = (row) => {
        get(`${apiConstants.RESET_PASSWORD}?username=${data?.username}`).then((res) => {
            if (res.data.message === 'Password is been reset successfully') {
                enqueueSnackbar('Password is been reset successfully', { variant: 'success' })
            }
            else {
                enqueueSnackbar(res.data.message, { variant: 'error' })
            }
            setClose(() => false)
        }).catch((err) => console.log(err))
    }

    const handleViewLogins = (row) => {
        setSelectedUser(row.username);
        setLogins(row.logins?.pastLogins?.slice().reverse() || []);
        setLoginModalOpen(true);
    }

    useEffect(() => {
        setIsLoading(true)
        const request = {
            "collection": "users",
            "andfilter": filter,
            "offset": page * sizePerPage,
            "limit": sizePerPage,
            "sort": {
                "field": "lastModifiedDate",
                "direction": "DESC"
            }
        }
        post(apiConstants.GET_USER, request).then((res) => {
            setUser(res?.data)
        }).catch((err) => console.log(err)).finally(() => setIsLoading(false))
    }, [reload, page, sizePerPage, filter])

    useEffect(() => {
        get(apiConstants.LIST_MODULE).then((res) => {
            const excluded = res.data?.length > 0 ? res.data.filter(val => val === "B2C_ACCESS" || val === "PTL_ACCESS") : [];
            // const modList = res.data?.length > 0 ? res.data.filter((val) => val !== "AP_RESTRICTED" && val !== "B2C_ACCESS" && val !== "PTL_ACCESS") : []
            const modList = res.data?.length > 0 ? res.data.filter((val) => val !== "ORDERS") : []
            // Define module descriptions
            const moduleDescriptions = {
                "ALL": "All Modules",
                "DASHBOARD": "Dashboard Access",
                "NDR": "Non-Delivery Report (NDR) Module",
                "PERFORMANCE": "Performance & Analytics",
                // "ORDERS": "Orders Management",
                "WEIGHT_DESC": "Weight Discrepancy Module",
                "TOOLS": "Tools & Utilities",
                "FINANCE": "Finance & Billing",
                "CT": "Courier Tracking",
                "REPORTS": "Reports & Analytics",
                "RETURNS": "Returns Management",
                "SETTINGS": "Settings & Configuration",
                "DASHBOARD_COURIER_LEVEL_DATA": "Dashboard Courier Level Data",
                "INTERNAL": "Internal Tools/Access",
                "MERCHANT_ADMIN": "Merchant Admin Panel",
                "MERCHANT_COURIER_ALLOCATION": "Courier Allocation Tab Access",
                "B2C_ACCESS": "D2C Freight Related Access",
                "PTL_ACCESS": "PTL Related Access",
                "SHOW_AMOUNT": "Merchant and Courier Pricing view access rights",
                "USER_SAVE": "Create User",
                "USER_RO": "User Read-Only Permissions",
                "VENDOR": "Vendor Management",
                "ORDER_TERMINAL_RESET": "Order Terminal Reset",
                "MERCHANT_ZONE_ADMIN": "Merchant Zone Mapping (base upload + overrides)"
            };

            // Convert modList to array of objects with description
            const modListWithDescriptions = modList.map((mod) => ({
                value: mod,
                label: moduleDescriptions[mod] || mod
            }));

            // Ensure 'ALL' is at the top
            if (!modListWithDescriptions.find(m => m.value === 'ALL')) {
                modListWithDescriptions.unshift({
                    value: 'ALL',
                    label: moduleDescriptions['ALL']
                });
            }
            setModule(modListWithDescriptions);
            setExcludedModules(excluded);

        }).catch((err) => console.log(err))
    }, [reload])


    const onSubmit = (data) => {
        setIsSubmitting(true);
        const trimmedName = data?.name?.trim();
        const trimmedStatus = data?.status?.trim();
        const trimmedRole = data?.role?.trim();
        const newFilters = [];
        if (trimmedName) {
            newFilters.push({
                "field": "username",
                "operator": "eq",
                "value": trimmedName.toLowerCase()
            });
        }
        if (trimmedStatus) {
            newFilters.push({
                "field": "status",
                "operator": "eq",
                "value": trimmedStatus
            });
        }
        if (trimmedRole) {
            newFilters.push({
                "field": "roles",
                "operator": "eq",
                "value": trimmedRole
            });
        }
        if (data?.merchant) {
            newFilters.push({
                "field": "parentMerchant",
                "operator": "eq",
                "value": data?.merchant
            });
        }
        setFilter(newFilters);
        setIsSubmitting(false);
    };


    const columns = [
        {
            field: 'fullName',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'User Name',
            width: 130,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {row?.fullName}
                            </Grid>
                        </Grid>
                    </>
                )
            },
        },
        {
            field: 'roles',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Roles',
            width: 160,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Grid container spacing={1}>
                        {row?.roles?.map((role, index) => (
                            <Grid item xs={12} key={index}>
                                {role}
                            </Grid>
                        ))}
                    </Grid>
                );
            },
        },
        {
            field: 'email',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Email Id ',
            width: 240,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Grid container spacing={1}>
                        <Grid item xs={12} >
                            {row?.email}
                        </Grid>
                    </Grid>
                )
            },
        },
        {
            field: 'merchant',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Assigned / Parent Merchant',
            width: 250,
            renderCell: (params) => {
                const { row } = params;
                if (row.roles.includes("ROLE_PROSHIPADMIN")) {
                    const merchantList = row?.merchantAccessOidList?.length > 0
                        ? merchants.filter((val) => row.merchantAccessOidList.includes(val.id))
                        : [];
                    return (
                        <Stack direction="row" spacing={0.75} alignItems="center">
                            {merchantList.length > 0 ? (
                                <Chip size="small" label={`${merchantList.length} merchant${merchantList.length > 1 ? 's' : ''}`} sx={{ fontWeight: 600 }} />
                            ) : (
                                <Chip size="small" color="info" variant="outlined" label="All merchants" />
                            )}
                            <Tooltip title="View assigned merchants">
                                <IconButton size="small" onClick={() => { setData(row); setViewMer(true); }}>
                                    <VisibilityOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    );
                } else if (row.roles.includes("ROLE_USER") || row.roles.includes("ROLE_ADMIN")) {
                    return (
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                    {merchants?.find((val) => val.id === row?.parentMerchant)?.name || "Parent not found"}
                                </Typography>
                            </Grid>
                        </Grid>
                    );
                }
                return null;
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <StatusToggle
                        row={row}
                        createAccess={createAccess}
                        setReload={setReload}
                    />
                );
            }
        },
        {
            field: 'createdDate',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Created Date',
            width: 160,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>{formatDate(row?.createdDate)} </>
                )
            },
        },
        {
            field: 'lastModifiedDate',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Modified Date',
            width: 160,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>{formatDate(row?.lastModifiedDate)} </>
                )
            },
        },
        {
            field: 'lastLogins',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Last Logins',
            width: 200,
            renderCell: (params) => {
                const { row } = params;
                const loginsArray = row?.logins?.pastLogins || [];
                return (
                    <Button variant="outlined" size="small" onClick={() => handleViewLogins(row)}>
                        View Last Logins ({loginsArray.length})
                    </Button>
                )
            },
        },
        ...(createAccess
            ? [{
                field: 'action',
                headerAlign: "left",
                hideSortIcons: true,
                align: 'left',
                headerName: 'Action',
                width: 100,
                renderCell: (params) => {
                    const { row } = params;
                    return (
                        <>
                            <Tooltip title="Edit">
                                <IconButton color="primary" size="small" onClick={() => openEditUserModal(row)}>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                            {/* <Tooltip title="Update Phone Number">
                                <IconButton color="primary" size="small" onClick={() => handleOpenPhoneModal(row)}>
                                    <ContactsIcon />
                                </IconButton>
                            </Tooltip> */}
                            <Tooltip title="Change Password">
                                <IconButton color="primary" size="small" onClick={() => handleReset(row)}>
                                    <LockResetIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Reset Password">
                                <IconButton color="primary" size="small" onClick={() => handleResetPassword(row)}>
                                    <SyncLockIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    );
                },
            }]
            : []),
    ]

    const downloadUserReport = () => {
        setIsDownloading(true);
        get(`${apiConstants.GET_USER_REPORT}?type=excel`).then((res) => {
            window.open(res?.data?.excel, '_blank');
            enqueueSnackbar("User report downloaded successfully", { variant: 'success' })
        }).catch((err) => {
            console.log(err)
            enqueueSnackbar(err?.response?.data?.message || "Error while downloading user report", { variant: 'error' })
        }).finally(() => setIsDownloading(false))
    }


    return (
        <>
            {isLoading && <Loader />}
            <PageTitle>User Management</PageTitle>
            <Card sx={{ pb: 2 }}>
                {createAccess &&
                    <CardHeader
                        action={
                            <Grid container spacing={2} justifyContent="flex-end" sx={{ mb: 2 }}>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        startIcon={<AddIcon />}
                                        color="warning"
                                        onClick={() => { openAddUserModal(MODAL_TYPES.ADD_USER) }}
                                    >
                                        Add Merchant Panel User
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        color="warning"
                                        startIcon={<AddIcon />}
                                        onClick={() => { openAddUserModal(MODAL_TYPES.ADD_ADMIN) }}                                >
                                        Add Admin / Internal User
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    />
                }
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                                <RHFTextField name='name' label='Full Email Id' />
                            </Grid>
                            <Grid item xs={3}>
                                <RHFSearchableSelectField name="merchant" label="Parent Merchant" width='100%' color="secondary" options={merchants?.map((val) => ({ label: val.name, value: val.id }))}
                                />
                            </Grid>
                            <Grid item xs={2} sx={{ overflow: 'hidden' }}>
                                <RHFSelectField name="status" label="Status" width='100%' color="secondary" options={[
                                    { label: "Active", value: "ACTIVE" },
                                    { label: "Inactive", value: "INACTIVE" },
                                    { label: "Active (Password Reset Required)", value: "RESET" },
                                ]}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <RHFSelectField name="role" label="Role" width='100%' color="secondary" options={[
                                    { label: "ROLE PROSHIPADMIN", value: "ROLE_PROSHIPADMIN" },
                                    { label: "ROLE USER", value: "ROLE_USER" },
                                    { label: "ROLE ADMIN", value: "ROLE_ADMIN" },
                                ]}
                                />
                            </Grid>
                            <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                >Search</LoadingButton>
                                <Button variant="contained" color="error" size="small" sx={{ ml: 1 }}
                                    onClick={() => {
                                        reset()
                                        setReload(reload + 1)
                                        setFilter([])
                                        setUser()
                                    }}>Reset</Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
            <Card sx={{ mt: 2 }}>
                {createAccess &&
                    <CardHeader
                        action={
                            <Grid container spacing={2} justifyContent="flex-end" sx={{ mb: 2 }}>
                                <Grid item>
                                    <LoadingButton
                                        loading={isDownloading}
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        startIcon={<DownloadIcon />}
                                        onClick={() => { downloadUserReport() }}                                >
                                        Download User Report
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        }
                    />
                }
                <CardContent>
                    <ProzoDataGrid
                        columns={columns}
                        autoHeight={true}
                        rows={user?.data ? user?.data : []}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        pagination={true}
                        hideFooterPagination={false}
                        rowHeight={120}
                        rowCount={user?.count || 0}
                        getRowId={(row) => row?.id} />

                </CardContent>
            </Card>

            {/* Modal for Last Logins */}
            <MUIModal
                open={loginModalOpen}
                handleClose={() => {
                    setLoginModalOpen(false); // Close modal
                    setSelectedUser(null); // Clear selected user
                    setLogins([]); // Clear previous logins
                }}
                maxWidth='md'
                title={`Last Logins for ${selectedUser}`} // Display the selected user's username
                children={
                    <table>
                        <thead>
                            <tr>
                                <th>Login Timestamps</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logins.map((login, index) => (
                                <tr key={index}>
                                    <td>{formatDate(login)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
            />
            <UserModals
                openModal={openModal}
                handleClose={handleClose}
                setReload={setReload}
                module={module}
                excludedModules={excludedModules}
                editData={editData}
                data={data}
                modalTypes={MODAL_TYPES}
            />
            <MUIModal open={resetPass} handleClose={handleClose} children={<PasswordReset row={data} setReload={setReload} setResetPass={setResetPass} />}
                title={"Change Password"} maxWidth='md' />

            <MUIModal open={viewMer} handleClose={handleClose} children={<ViewMerchant merData={data} merchants={merchants} />}
                title={"Merchant Access List"} maxWidth='sm' />

            {/* <MUIModal open={openPhoneModal} handleClose={handleClose} children={<UpdatePhoneModal val={phoneData} setReload={setReload} handleClose={handleClose} />}
                title={"Update Phone Number"} maxWidth='md' /> */}

            <MUIModal open={close} handleClose={handleClose} maxWidth='sm' children={<DialogContentText id="alert-dialog-description">
                Do you want to reset the password of <span style={{ fontWeight: 'bold' }}>{data?.username}</span>?
            </DialogContentText>}
                title={"Reset Password"}
                action={<Button variant="contained" color='error' onClick={() => Reset(data)} autoFocus>
                    Reset
                </Button>} />
        </>
    )
}

export default UserManagementPanel;

// table to assigned merchant list to proship admin
const ViewMerchant = ({ merData, merchants }) => {
    const merchantList = merData?.merchantAccessOidList?.length > 0 && merchants.filter((val) => merData.merchantAccessOidList.includes(val.id));

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Merchants
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {merchantList?.length > 0 ? (
                        merchantList.map((val, index) => (
                            <TableRow key={index}>
                                <TableCell>{val.name}</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={1} align="center">
                                <Typography variant="subtitle1" color="textSecondary">
                                    All merchants are assigned
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </>
    );

}


// const UpdatePhoneModal = ({ val, setReload, handleClose }) => {
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const { enqueueSnackbar } = useSnackbar();

//     const onSubmit = (data) => {
//         setIsSubmitting(true)
//         const payload = {
//             "username": data?.userName,
//             "phoneNumber": data?.phoneNumber
//         }
//         post(apiConstants.UPDATE_USER_PHONENUMBER, payload).then((res) => {
//             enqueueSnackbar(res?.data?.message, { variant: 'success' })
//             setReload((reload) => reload + 1)
//             handleClose()
//         }).catch((err) => {
//             console.log(err)
//             enqueueSnackbar(err?.response?.data?.message, { variant: 'error' })
//         }).finally(() => setIsSubmitting(false))
//     }

//     const methods = useForm({
//         resolver: yupResolver(
//             Yup.object().shape({
//                 phoneNumber: Yup.string()
//                     .required("Phone Number is required")
//                     .matches(
//                         /^\d{10}$/,
//                         "Phone Number must be exactly 10 digits"
//                     )
//             })
//         ),
//         defaultValues: {
//             userName: "",
//             phoneNumber: ""
//         },
//     });
//     const { handleSubmit } = methods;

//     useEffect(() => {
//         if (val) {
//             methods.setValue('userName', val?.email)
//             methods.setValue('phoneNumber', val?.mobile)
//         }
//     }, [val])

//     return (
//         <>
//             <Card>
//                 <CardContent>
//                     <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
//                         <Grid container spacing={2}>
//                             <Grid item xs={4}>
//                                 <RHFTextField name='userName' label="User Name" disabled />
//                             </Grid>
//                             <Grid item xs={4}>
//                                 <RHFTextField name="phoneNumber" label="Phone Number" placeholder="Enter Phone Number" />
//                             </Grid>
//                             <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <LoadingButton
//                                     loading={isSubmitting}
//                                     variant="contained"
//                                     size="small"
//                                     type="submit"
//                                 >
//                                     Submit
//                                 </LoadingButton>
//                             </Grid>
//                         </Grid>
//                     </FormProvider>
//                 </CardContent>
//             </Card>
//         </>
//     );
// }
